import { getData } from "../helpers/recentlyViewed";

const MAX_PRODUCTS = 4;

class SearchRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    this._populate = () => {
      this.data = getData();

      if (this.data.length) {
        const contentTemplate = this.querySelector("template").cloneNode(true);
        const contentWrapper = this.querySelector("[data-content-wrapper]");

        const container =
          contentTemplate.content.querySelector("[data-container]");

        const productsToDisplay = this.data.slice(0, MAX_PRODUCTS);

        if (productsToDisplay.length) {
          container.innerHTML = productsToDisplay
            .map((item) => item.predictiveSearchCardMarkup)
            .join("");

          contentWrapper.innerHTML = "";
          contentWrapper.append(contentTemplate.content);

          this.setAttribute("has-content", "");
        }
      }
    };

    this._populate();
  }

  connectedCallback() {
    document.addEventListener("recently-viewed:refreshed", this._populate);
  }

  disconnectedCallback() {
    document.removeEventListener("recently-viewed:refreshed", this._populate);
  }
}

if (!customElements.get("search-recently-viewed")) {
  customElements.define("search-recently-viewed", SearchRecentlyViewed);
}
